(function ($) {

    $.fn.paginate = function (options) {

        //Default options
        var settings = $.extend({
            rows: 6,
            position: "bottom",
            jqueryui: true,
            showIfLess: true
        }, options);

        $(this).each(function () {
            var currentPage = 0;
            var rowPerPage = settings.rows;
            var table = $(this);
            table.bind('pageTable', function () {
                table.find('tbody tr').hide().slice(currentPage * rowPerPage, (currentPage + 1) * rowPerPage).show();
            });
            table.trigger('pageTable');
            var numRows = table.find('tbody tr').length;
            var numPages = Math.ceil(numRows / rowPerPage);
            var pager = $('<div class="pager"></div>');

            //Check ui theming====================================================================
            var activeclass = settings.jqueryui ? "ui-state-active" : "active";
            var defaultclass = settings.jqueryui ? "ui-state-default" : "number";

            // Add page info
            var pageInfo = $('<div class="page-info"></div>');
            table.bind('pageTable', function () {
                pageInfo.text( '1-' + numPages+ ' of ' + (currentPage + 1));
            });
            pager.append(pageInfo);
            pageInfo.text( '1-' + numPages + ' of ' + (currentPage + 1));

            // Add 'prev' button
            $('<span class="' + defaultclass + ' prev"></span>').bind('click', function () {
                if (currentPage > 0) {
                    currentPage--;
                    table.trigger('pageTable');
                    pager.children().removeClass(activeclass);
                    pager.children().eq(currentPage + 1).addClass(activeclass);  // +1 for 'prev' button
                }
            }).appendTo(pager).addClass('clickable');

            // Add 'next' button
            $('<span class="' + defaultclass + ' next"></span>').bind('click', function () {
                if (currentPage < numPages - 1) {
                    currentPage++;
                    table.trigger('pageTable');
                    pager.children().removeClass(activeclass);
                    pager.children().eq(currentPage + 1).addClass(activeclass);  // +1 for 'prev' button
                }
            }).appendTo(pager).addClass('clickable');


            //Add pager===========================================================================
            if (settings.showIfLess) {

                if (settings.position == "bottom") {
                    pager.insertAfter(table).find('span.' + defaultclass + ':first').next().addClass(activeclass);
                }
                else if (settings.position == "top") {
                    pager.insertBefore(table).find('span.' + defaultclass + ':first').next().addClass(activeclass);
                }
            }
            else if (rowPerPage < numRows) {
                if (settings.position == "bottom") {
                    pager.insertAfter(table).find('span.' + defaultclass + ':first').next().addClass(activeclass);
                }
                else if (settings.position == "top") {
                    pager.insertBefore(table).find('span.' + defaultclass + ':first').next().addClass(activeclass);
                }
            }
        });

        return this;
    }

})(jQuery);
